import React from 'react';
import { render } from '@testing-library/react';
import { Tag } from './Tag';

describe('Tag', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<Tag title="Title" data-auto-sel="automation-selector">
				Tag
			</Tag>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});
});
